/**
 * a2ui SESSION catalog constants + renderer-capability advertisement (DEC-3/DEC-8).
 *
 * These ids are the SSOT-mirrored strings the api-server gates on
 * (`api-server/app/services/render_scheme.py`: A2UI_SESSION_CATALOG_ID) and the
 * published session catalog (`backend/widget-native/a2ui/native-ir-session.catalog.json`).
 * The web is always a capable a2ui renderer, but we still SEND the capabilities
 * on session-create + exec — it is exactly what an external a2ui 1.0 client would
 * advertise, and the background goal (any a2ui app consuming our sessions) needs
 * the negotiation to be real from day one.
 */

export const A2UI_PROTOCOL_VERSION = 'v1.0';

export const SESSION_CATALOG_ID = 'https://viagent.collov.ai/a2ui/v1.0/native-ir-session.json';
export const WIDGETS_CATALOG_ID = 'https://viagent.collov.ai/a2ui/v1.0/native-ir-widgets.json';
export const BASIC_CATALOG_ID = 'https://a2ui.org/specification/v1_0/catalogs/basic/catalog.json';

/** The exec/create-body `a2ui` value an a2ui-capable renderer sends (DEC-8). */
export function rendererCapabilities() {
  return {
    rendererCapabilities: {
      'v1.0': { supportedCatalogIds: [BASIC_CATALOG_ID] }, // P9: session vocabulary = basic; legacy id accept-only
    },
  };
}

/**
 * A v1 `follow_up` renderer→agent action envelope (DEC-8) — the ONE action a
 * released a2ui client posts back. Shape mirrors
 * `contracts/a2ui/spec/v1_0/json/renderer_to_agent.json#/properties/action`
 * (api-server relaxes `timestamp`/`context` to optional).
 */
export function followUpAction({ surfaceId, sourceComponentId, context, userMessage }) {
  const action = { name: 'follow_up' };
  if (surfaceId) action.surfaceId = surfaceId;
  if (sourceComponentId) action.sourceComponentId = sourceComponentId;
  action.timestamp = new Date().toISOString();
  action.context = context && typeof context === 'object' ? context : {};
  if (userMessage != null) action.userMessage = String(userMessage);
  return { version: 'v1.0', action };
}

/**
 * The 14 session-catalog CUSTOM component names (native-ir-session catalog) —
 * each renders through the existing viewIr session-block kit unchanged (smart
 * wrapper). `before_after`/`agent_speech` included for completeness.
 */
export const SESSION_CUSTOM_COMPONENTS = new Set([
  'hero_media', 'before_after', 'stat_grid', 'table', 'chip_list', 'icon_list',
  'numbered_steps', 'image_gallery', 'link_preview', 'location', 'shopping_list',
  'video_player', 'file_card', 'worker_delegate',
]);

/** a2ui core component → the viewIr session-block type it renders as. */
export const CORE_TO_SESSION_BLOCK = {
  Text: 'markdown',
  Divider: 'markdown',
};
